<mat-drawer-container (backdropClick)="backdropClick()" [ngClass]="{

    'mat-drawer-container-unset': _showModal == true

   }" class="main-content" [hasBackdrop]="true">
  <mat-drawer class="side-bar" [ngClass]="{
    'mat-drawer-position': _showModal == true
   }" #drawer [position]="'end'" [mode]="'over'">
    <neoris-incident-record [Mode]="'modal'" [Data]="incidentRecordData"
      (closeModalEvent)="hideModal($event)"></neoris-incident-record>
  </mat-drawer>
  <mat-drawer-content>


    <div class="container header-container" [formGroup]="filters">
      <div class="half-container title-container">
        <p class="title">{{ 'TITLE_HEAD_CONTROL_TOWERS' | translate }}</p>
        <p class="subtitle">{{ 'SUBTITLE_HEAD_CONTROL_TOWERS' | translate }}</p>
      </div>
      <div class="half-container">
        <div class="cards1">
          <div class="visual-search-container">
            <span class="visual-search-text">{{ "VISUAL_SEARCH" | translate }}</span>
            <mat-chip-grid #chipGrid aria-label="Enter search keywords:">
              @for (fruit of keywords(); track fruit) {
              <mat-chip-row (removed)="removeKeyword(fruit)" [aria-description]="'press enter to edit ' + fruit">
                {{fruit}}
                <button matChipRemove [attr.aria-label]="'remove ' + fruit">
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip-row>
              }
              <input placeholder="New fruit..." [matChipInputFor]="chipGrid"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                (matChipInputTokenEnd)="add($event)" />
            </mat-chip-grid>
        
            <div class="incidents-result-container">
              <span class="incident-result-text">{{ "TOP-TEXT" | translate }}</span>
              <mat-select formControlName="incidentResults" id="incidentResults" class="select-centrado">
                <mat-option *ngFor="let option of arrayCountResults" [value]="option">{{option}}</mat-option>
              </mat-select>
            </div>
           
        
            <button id="visual-search-button" mat-raised-button (click)="searchButtonClick()">
              <span class="confirm-ico-btn"></span>
              {{ "SEARCH" | translate }}
            </button>
          </div>
        </div>


        <div class="cards1">
          <div class="card1">
            <div class="select">
              <mat-form-field color="white" class="matformSelect">
                <mat-label class="textSelect">
                  {{ "incidentType" | translate }}
                </mat-label>
                <mat-select #selIncidentType formControlName="incidentType" multiple>

                  <mat-select-trigger>
                    <span *ngIf="((filters.get('incidentType').value?.length || 0) == 1)">
                      {{ filters.get('incidentType').value[0]?.name || "SELECT_ALL" | translate }}
                    </span>
                    <span
                      *ngIf="((filters.get('incidentType').value?.length || 0) > 1 && filters.get('incidentType').value[0]?.name !== undefined)">
                      {{ filters.get('incidentType').value[0]?.name || "SELECT_ALL" | translate }}
                    </span>

                    <span
                      *ngIf="((filters.get('incidentType').value?.length || 0) > 1 && filters.get('incidentType').value[0]?.name == undefined)">
                      {{ filters.get('incidentType').value[1]?.name || "SELECT_ALL" | translate }}
                    </span>

                    <span *ngIf="((filters.get('incidentType').value?.length || 0) > 1)">
                      (+{{(filters.get('incidentType').value?.length || 0) - 1}} {{filters.get('incidentType')?.length
                      === 2 ? '...' : '...'}})
                    </span>
                  </mat-select-trigger>


                  <mat-option (click)="toggleAllSelection(selIncidentType)" [value]="0">{{ "SELECT_ALL" | translate
                    }}</mat-option>
                  <mat-option *ngFor="let option of arrayIncidentsTypes" [value]="option">{{option.name}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="card1">
            <div class="selectDate">
              <mat-form-field class="matformDate">
                <mat-label class="textSelect">
                  <!-- {{ "ENTER_DATE_RANGE" | translate }} -->
                  <p class="textSelect">{{ "YEAR_MONTH_DAY" | translate }}</p>
                </mat-label>
                <mat-date-range-input [rangePicker]="picker">
                  <input matStartDate formControlName="start" #dateRangeStart>
                  <!-- (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)" -->
                  <input matEndDate formControlName="end" #dateRangeEnd>
                </mat-date-range-input>
                <!-- <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint> -->
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker (closed)="onDatepickerClosed()"></mat-date-range-picker>
              </mat-form-field>

            </div>
          </div>
          <div class="card1">
            <div class="select">
              <mat-form-field color="white" class="matformSelect matformSelect-status">
                <mat-label class="textSelect">
                  {{ "incidentStatus" | translate }}
                </mat-label>
                <mat-select #selStatus formControlName="status" multiple>

                  <mat-select-trigger>
                    <span *ngIf="((filters.get('status').value?.length || 0) == 1)">
                      {{ filters.get('status').value[0]?.name || "SELECT_ALL" | translate }}
                    </span>
                    <span
                      *ngIf="((filters.get('status').value?.length || 0) > 1 && filters.get('status').value[0]?.name !== undefined)">
                      {{ filters.get('status').value[0]?.name || "SELECT_ALL" | translate }}
                    </span>

                    <span
                      *ngIf="((filters.get('status').value?.length || 0) > 1 && filters.get('status').value[0]?.name == undefined)">
                      {{ filters.get('status').value[1]?.name || "SELECT_ALL" | translate }}
                    </span>

                    <span *ngIf="((filters.get('status').value?.length || 0) > 1)">
                      (+{{(filters.get('status').value?.length || 0) - 1}} {{filters.get('status')?.length === 2 ? '...'
                      : '...'}})
                    </span>
                  </mat-select-trigger>

                  <mat-option (click)="toggleAllSelection(selStatus)" [value]="0">{{ "SELECT_ALL" | translate
                    }}</mat-option>
                  <mat-option *ngFor="let option of arrayIncidentStatus" [value]="option">{{option.name}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <!-- <div class="card1 button-card">
            <button mat-raised-button (click)="searchButtonClick()">
              <span class="confirm-ico-btn"></span>
              {{ "SEARCH" | translate }}
            </button>
          </div> -->
        </div>
      </div>
    </div>


    <div class="card-container">

      <div *ngFor="let eventType of modelIncident.eventTypes" class="card clickeable-card"
        (click)="cardClick(eventType)" [ngClass]="{
        'card-active': activeFilter == eventType.id
      }">
        <div class="imageCard">
          <img src="{{  eventType.urlIcon }}" alt="Imagen">
        </div>

        <div class="card-body">
          <div>
            <p class="card-title">
              {{ eventType.kpiI18N.text }}
              <!-- <span class="exclamation_mark"></span> -->
            </p>
          </div>
          <div>
            <!--  modelIncident.redZoneTotal -->
            <p class="card-text">{{ eventType.total }} <span
                *ngIf="eventType.characterTotal != null">{{eventType.characterTotal}}</span> </p>
          </div>
          <div>
            <p class="cardSubText">{{ eventType.kpiI18N.toolTip }}</p>
          </div>
        </div>
      </div>

    </div>
    <neoris-grid [ColumnsConfiguration]="gridColumnsConfiguration" [GridTitle]="gridTitle"
      [Data]="arrayGirdControlTower" (cellClickEvent)="cellClick($event)" [Filter]="gFilter"
      [ShowChecks]="false"></neoris-grid>

    <br>

  </mat-drawer-content>
</mat-drawer-container>